import { alertConstants } from "../_constants";

// initial status of alert object
const initialState = {
  alert: null,
};

export function alert(state = initialState, action) {
  switch (action.type) {
    case alertConstants.ADD_ALERT:
      return {
        ...state,
        alert: action.payload,
      };
    case alertConstants.REMOVE_ALERT:
      return { ...state, alert: action.payload };
    default:
      return state;
  }
}
